import Button from '2-core-elements/Buttons/Button';
import { type IconString } from '2-core-elements/Icon/Icon';
import type { ClickOrPressEvent } from 'types/mouseEvents';

interface LargeMonthlyNodgeProps {
    callToAction: string;
    buttonText: string;
    buttonOnClick?: () => void;
    buttonIcon?: IconString;
}

export default function LargeMonthlyNudge({ callToAction, buttonText, buttonIcon = 'volunteer', buttonOnClick }: LargeMonthlyNodgeProps): JSX.Element {
    return (
        <div className="large-monthly-nudge-wrapper">
            <div className="large-monthly-nudge-text">{callToAction}</div>
            <Button
                skin="1"
                size="md"
                className="large-monthly-nudge-button"
                prefixIcon={buttonIcon}
                fullWidth={true}
                onClick={(e: ClickOrPressEvent): void => {
                    e.preventDefault();
                    if (buttonOnClick) {
                        buttonOnClick();
                    }
                }}
            >
                {buttonText}
            </Button>
        </div>
    );
}
